module.exports = __webpack_public_path__ + "media/assets/images/connectors/aws-logo-b6e95e0a7891cbff4f1144c7a4d7bb80.svg";